import React, { useState, useEffect, useRef } from "react";
import { Text } from "src/components/ui/Text";
import { BaseButton } from "src/components/ui/baseButton";
import { CancelIcon } from "../icons";
import { useTranslation } from 'react-i18next'

const MultiSearchBar = ({ searchInput, setSearchInput, dropdownGroupSearch, groupSearch, setGroupSearch,reportDataList,setDataReport}) => {
  const ref = useRef(null);
  const { t } = useTranslation("settings");
  const [isInputFocused, setIsInputFocused] = useState(false);
  // const newDropdownGroupSearch = dropdownGroupSearch?.filter(
  //   (list) => !groupSearch?.includes(list)
  // );

  const newDropdownGroupSearch = dropdownGroupSearch;

  useEffect(() => {
    //user click outside
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsInputFocused(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  const handleInputFocus = () => {
    setIsInputFocused((focus) => !focus);
  };

  const handleSelect = (word) => {
    if (groupSearch.includes(word)) {
      setGroupSearch(groupSearch.filter((item) => item !== word));
    } else {
      setGroupSearch([...groupSearch, word]);
    }
  };

  const handleSearch = () => {
    if (reportDataList) {
      if (groupSearch.length > 0) {
        const filterGroupSearch = reportDataList?.filter((list) =>
          groupSearch
            ?.map((word) => word?.toLowerCase()?.trim()?.replaceAll(" ", ""))
            .includes(list?.device?.toLowerCase()?.trim()?.replaceAll(" ", ""))
        );
        setDataReport(filterGroupSearch);
        setIsInputFocused(false);
      } else {
        setDataReport(reportDataList);
      }
    }
  };

  const renderDisplayText = () => {
    const maxDisplay = 5; 
    const displayItems = groupSearch.slice(0, maxDisplay);
    const remainingCount = groupSearch.length - maxDisplay;
  
    return (
      <div className="flex items-center gap-1 p-1 w-full overflow-y-auto">
        {displayItems.map((option, index) => (
          <div
            key={index}
            className="flex items-center text-nowrap border border-green-300 bg-green-50 rounded-3xl px-2 py-1"
          >
            <span className="text-green-700">{option}</span>
            <button
              className="ml-2 text-gray-800 bg-gray-200 hover:bg-gray-300 rounded-full size-5 flex justify-center items-center"
              onClick={() =>
                setGroupSearch(groupSearch.filter((_, i) => i !== index))
              }
            >
              <CancelIcon />
            </button>
          </div>
        ))}
  
        {remainingCount > 0 && (
          <span className="text-gray-500 text-[10px]">
            & {remainingCount} {t('settings:report.selected')}
          </span>
        )}
      </div>
    );
  };
  


  return (
    <div className="flex gap-2 items-center w-full max-w-lg" ref={ref}>
      <div className="relative w-full min-w-[12.5rem] max-w-[25rem]">
     
            {/* Selected Options */}
            <div className="relative flex items-center flex-wrap w-full border border-gray-200 rounded-lg text-sm focus:ring focus:ring-blue-500 ">
              <div className="overflow-y-auto ">{renderDisplayText()}</div>

              <input
                type="text"
                placeholder={t('settings:report.placeholder_search')}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.target.value !== "" && e.key === "Enter") {
                    e.preventDefault();
                    setGroupSearch([...groupSearch, e.target.value]);
                    // setSearchInput("");
                  }
                }}
                onFocus={handleInputFocus}
                className="py-2 px-2 rounded-lg text-sm w-full"
              />
            </div>

        {/* Dropdown Options */}
        {isInputFocused ? (
          newDropdownGroupSearch?.length > 0 ? (
            <ul className="absolute mt-2 z-50 w-full min-h-[9.375rem] max-h-[17.5rem] pb-1 px-1 space-y-0.5 bg-white border border-gray-200 rounded-lg overflow-y-auto">
                {newDropdownGroupSearch
                  ?.filter((word) =>
                    word
                      ?.toLowerCase()
                      ?.replaceAll(" ", "")
                      ?.includes(searchInput?.toLowerCase()?.trim()?.replaceAll(" ", ""))
                  )
                  ?.map((word, index) => {
                    // Find the record for the current word
                    const recordData = reportDataList.find(
                      (item) =>
                        item.device?.toLowerCase()?.trim()?.replaceAll(" ", "") ===
                        word?.toLowerCase()?.trim()?.replaceAll(" ", "")
                    );
                    const record = recordData?.record ?? t('settings:report.no_record'); // Default if no record found
                    const isSelected = groupSearch.includes(word); // Check if the word is selected

                    return (
                      <li
                        key={`${word}_${index}`}
                        onClick={() => handleSelect(word)}
                        className="flex items-center py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg"
                      >
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => handleSelect(word)} // Toggle selection on checkbox change
                          className="mr-2 w-4 h-4 rounded accent-emerald-700 focus:ring-3 focus:ring-vekin"
                        />
                        <div className="flex justify-between items-center w-full">
                          <div className="text-sm font-semibold">{word}</div>
                          <div className="text-xs text-gray-500">{record} {t('settings:report.record')}</div>
                        </div>
                      </li>
                    );
                  })}
              </ul>

          ) : (
            <div className="absolute top-[2.625rem] left-0 z-20 flex justify-center items-center w-full min-h-[9.375rem] max-h-[17.5rem] rounded-lg bg-white overflow-y-auto border border-quartenary">
              <Text variant="medium-14" className="text-secondary">
                {t('settings:report.no_data')}
              </Text>
            </div>
          )
        ) : (
          ""
        )}

      </div>

      <div className="flex gap-2 items-center">
            <BaseButton
              variant="primary"
              size="normal"
              onClick={handleSearch}
            >
              <div className="flex gap-2">
                <i className={`ri-search-line text-vekin-gray10`}></i>
                <Text variant="semi-12" className="text-white">
                  {t('settings:report.search_button')}
                </Text>
              </div>
            </BaseButton>
      </div>
      
    </div>
  );
};
export default MultiSearchBar;
